import { useState, useEffect } from "react";
import { api } from "../lib/api";

// Where a captured lead can go, and whether this workspace has actually set any of it up.
//
// The Attack surface lead magnet is the only thing these three connectors serve, but they
// are configured two screens away under Settings -> Integrations. Someone can therefore
// build a widget, embed it, collect leads — and never learn that none of them reached
// their CRM, because nothing on the lead magnet screen ever mentioned the connection.
//
// Each endpoint answers { configured, enabled } and 404s/500s are treated as "not
// configured": this panel is a prompt, and a failed status check must never present as a
// broken integration or block the builder.
const SOURCES = [
  { id: "gohighlevel", name: "GoHighLevel", path: "s2/api/ghl/config" },
  { id: "hubspot",     name: "HubSpot",     path: "s2/api/hubspot/config" },
  { id: "zoho",        name: "Zoho",        path: "s2/api/zoho/config" },
];

export function useLeadDestinations() {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const rows = await Promise.all(SOURCES.map(async (s) => {
        try {
          const d = await api.get(s.path);
          return { ...s, configured: !!d?.configured, enabled: !!d?.enabled };
        } catch {
          return { ...s, configured: false, enabled: false, unknown: true };
        }
      }));
      if (!cancelled) { setDestinations(rows); setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  // "Live" is configured AND switched on: a connector saved but disabled sends nothing,
  // which is exactly the case someone needs telling about.
  const live = destinations.filter((d) => d.configured && d.enabled);
  const dormant = destinations.filter((d) => d.configured && !d.enabled);

  return { destinations, live, dormant, loading, anyLive: live.length > 0 };
}
